import { useCallback } from 'react'

import { useSearchParams } from 'shared/hooks/useSearchParams'

export const useItemModal = <T extends string>(
  paramName: T = 'itemId' as T
) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const close = useCallback(
    (options?: {
      /**
       * Passing `true` will remove the history
       */
      force?: boolean
    }) => {
      setSearchParams(
        { [paramName]: undefined } as Partial<Record<T, string>>,
        { replace: options?.force }
      )
    },
    [paramName, setSearchParams]
  )

  const open = useCallback(
    (id: number) => {
      setSearchParams({ [paramName]: id.toString() } as Partial<
        Record<T, string>
      >)
    },
    [paramName, setSearchParams]
  )

  return {
    itemId: +(searchParams.get(paramName) ?? 0) || undefined,
    close,
    open
  }
}
